export const SLOT_CARD_ICON_TARGET_SIZE = { base: '48px', md: '36px' } as const;
export const SLOT_CARD_ACTION_ICON_SIZE = { base: 6, md: 5 } as const;
